import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import * as Highcharts from 'highcharts';
import { ReusableFunctions } from '../../../shared/classes/reusable-functions';
import {
    PerformanceScorecardService,
    ScorecardProductionWebModel,
    ScorecardEmployeeWebModel,
    IProductionPurposeMixPieChartData,
    IScorecardParameters,
    ScorecardType,
} from '../../services/performance-scorecard.service';
import { DisplayOptions } from '../../../shared/interfaces/display-options';
import {
    NoDataTypes,
    NoDataActionType,
    NoDataSourceType,
} from '../../../shared/interfaces/no-data';
import {
    ScorecardKpicardDataHandler,
    IScorecardKpiParams,
} from '../../../shared/classes/scorecards-kpi-card-data-handler';
import { ICardlistData } from '../../../shared/components/card-list/card-list.component';
import { IPageHeadline } from '../../../shared/classes/page-title-parameters';
import { DomSanitizer } from '@angular/platform-browser';
import { ILargeCardInteriorOptions } from '../../../shared/interfaces/card-data';
import { IScorecardDetailsCardData } from '../../../shared/components/scorecards-score-summary-card/scorecards-score-summary-card.component';

@Component({
    selector: 'app-performance-scorecard-employee-type',
    templateUrl: './performance-scorecard-employee-type.component.html',
    styleUrls: ['./performance-scorecard-employee-type.component.scss'],
})
export class PerformanceScorecardEmployeeTypeComponent implements OnInit {
    fromDatePeriod: string = 'This Year';
    ymc: string;
    employeeIdentifier: string;
    employeeType = 'Loan Originator';
    employeeTypeUrl: string;
    pageTitleShort = null;
    pageTitle = null;
    employeeIdentifierRoute: string;
    employeeList: ScorecardEmployeeWebModel[];
    displayOptions: DisplayOptions[];
    isDataLoded = false;
    pageId = 'performanceScorecardEmployeeType';
    employeeListSettings: any;
    selectedEmployee: ScorecardEmployeeWebModel[];
    noDataSelection: NoDataTypes;
    kpiCardData: ICardlistData;
    action: NoDataActionType;
    employeeFoundInList: boolean;
    productionPurposeMixPieChartData: IProductionPurposeMixPieChartData;
    largeCardInteriorOptions: ILargeCardInteriorOptions;
    detailsCard: IScorecardDetailsCardData;

    pageHeadline: IPageHeadline = {
        module: 'performance',
        moduleIcon: 'fa-heartbeat',
        pageTitle: '',
        linkArray: [
            {
                moduleLink: 'performance',
                linkTitle: 'Performance Home',
                showLink: true,
                isHome: true,
            },
            //{
            //    moduleLink: 'performance/insights/kpi',
            //    linkTitle: 'KPI Insights',
            //    showLink: true,
            //    hideIf: ['performance/scorecards/lo'],
            //},
            {
                moduleLink: '/performance/scorecards',
                linkTitle: 'Performance Scorecards',
                showLink: true,
                hideIf: ['performance/insights/kpi'],
            },
        ],
    };

    constructor(
        private performanceScorecardService: PerformanceScorecardService,
        private route: ActivatedRoute,
        private router: Router,
        private _reusableFunctions: ReusableFunctions,
        private sanitizer: DomSanitizer
    ) {}

    ngOnInit() {
        this.employeeTypeUrl = this.route.snapshot.routeConfig.path;

        switch (this.employeeTypeUrl) {
            case 'scorecards/processor':
                this.employeeType = 'Processor';
                this.pageTitleShort = 'Processor';
                this.pageTitle = 'Processor Scorecard';
                this.pageHeadline.pageTitle = this.pageTitle;
                break;
            case 'scorecards/ae':
                this.employeeType = 'Account Executive';
                this.pageTitleShort = 'Account Executive';
                this.pageTitle = 'Account Executive Scorecard';
                this.pageHeadline.pageTitle = this.pageTitle;
                break;
            case 'scorecards/closer':
                this.employeeType = 'Closer';
                this.pageTitleShort = 'Closer';
                this.pageTitle = 'Closer Scorecard';
                this.pageHeadline.pageTitle = this.pageTitle;
                break;
            case 'scorecards/loa':
                this.employeeType = 'Loan Originator Assistant';
                this.pageTitleShort = 'LOA';
                this.pageTitle = 'Loan Originator Assistant Scorecard';
                this.pageHeadline.pageTitle = this.pageTitle;
                break;
            case 'scorecards/underwriter':
                this.employeeType = 'Underwriter';
                this.pageTitleShort = 'Underwriter';
                this.pageTitle = 'Underwriter Scorecard';
                this.pageHeadline.pageTitle = this.pageTitle;
                break;
            case 'scorecards/post-closer':
                this.employeeType = 'Post Closer';
                this.pageTitleShort = 'Post Closer';
                this.pageTitle = 'Post Closer Scorecard';
                this.pageHeadline.pageTitle = this.pageTitle;
                break;
            case 'scorecards/funder':
                this.employeeType = 'Funder';
                this.pageTitleShort = 'Funder';
                this.pageTitle = 'Funder Scorecard';
                this.pageHeadline.pageTitle = this.pageTitle;
                break;
            default:
                this.employeeType = 'Loan Originator';
                this.pageTitleShort = 'Loan Originator';
                this.pageTitle = 'Loan Originator Scorecard';
                this.pageHeadline.pageTitle = this.pageTitle;
                break;
        }

        scroll(0, 0);
        this.action = NoDataActionType.pageStart;
        Highcharts.setOptions({
            lang: {
                decimalPoint: '.',
                thousandsSep: ',',
            },
        });

        this.noDataSelection = {
            action: NoDataActionType.emptySelect,
            searchTerm: this.employeeType,
            componentTitle: '',
            inputSource: NoDataSourceType.largeDataCard,
            wrapInACard: true,
        };

        this.employeeListSettings = {
            singleSelection: true,
            text: `Select ${this.employeeType}`,
            enableSearchFilter: true,
            showCheckbox: false,
            labelKey: 'employee',
            primaryKey: 'employeeIdentifier',
            enableFilterSelectAll: false,
        };

        this.productionPurposeMixPieChartData =
            this.performanceScorecardService.initializeDonutcharts();
        this.largeCardInteriorOptions = this.performanceScorecardService.initializeProductionChart(
            this.pageId,
            this.action
        );

        this.displayOptions = this._reusableFunctions.getCurrentDisplayOptions(
            `/performance/${this.employeeTypeUrl}`
        );
        this.setDisplayOptionsSelected();

        // Check if idenfier is passed from KPI insight.
        this.route.queryParamMap.subscribe((p) => {
            if (p) {
                if (p.get('employeeIdentifier')) {
                    this.employeeIdentifierRoute = p.get('employeeIdentifier');

                    if (this.employeeIdentifierRoute) {
                        this.employeeIdentifier = this.employeeIdentifierRoute;
                    }
                } else if (p.get('id')) {
                    this.employeeIdentifierRoute = p.get('id');

                    if (this.employeeIdentifierRoute) {
                        this.employeeIdentifier = this.employeeIdentifierRoute;
                    }
                }
            }
        });

        this.checkEmployeeListChanges();
    }

    // DISPLAY OPTIONS /////////////////////////////
    setDisplayOptionsSelected() {
        if (this.displayOptions.find((item) => item.optionKey === 'dateRangeRolling')) {
            this.fromDatePeriod = this.displayOptions.find(
                (item) => item.optionKey === 'dateRangeRolling'
            ).selectedOptions;
        }

        if (this.displayOptions.find((item) => item.optionKey === 'scorecardAsOf')) {
            this.ymc = this.displayOptions.find(
                (item) => item.optionKey === 'scorecardAsOf'
            ).selectedOptions;
        }
    }

    loadData() {
        this.setPositionDetails();
        this.setFundedProduction();
        this.kpiInit();
        this.setProductPurposeMixCard();
    }

    loEmployeeDisplayOptionsInit() {
        return new Promise((resolve) => {
            this.performanceScorecardService
                .getEmployeeList(this.employeeType, this.fromDatePeriod, this.ymc)
                .subscribe(
                    (res) => {
                        this.employeeList = res;
                        for (let emp of this.employeeList) {
                            emp.forced = false;
                        }

                        if (
                            !this.employeeIdentifierRoute &&
                            this.employeeList &&
                            this.employeeList.length > 0
                        ) {
                            if (!this.isDataLoded) {
                                this.employeeList = this.employeeList.filter((e) => e.employee);
                            }
                        }

                        if (this.employeeIdentifier) {
                            let recordInList = this.employeeList.find(
                                (x) => x.employeeIdentifier === this.employeeIdentifier
                            );

                            if (recordInList) {
                                this.selectedEmployee = [recordInList];
                                this.employeeFoundInList = true;
                            } else {
                                this.employeeFoundInList = false;
                                if (this.selectedEmployee && this.selectedEmployee[0]) {
                                    // We will add the missing employee back to the list and then force a load of
                                    // noData for each of the cards
                                    this.selectedEmployee[0].forced = true;
                                    this.employeeList.push(this.selectedEmployee[0]);
                                    this.employeeList.sort((employeeA, employeeB) => {
                                        if (employeeA.employee < employeeB.employee) {
                                            return -1;
                                        }
                                        if (employeeA.employee > employeeB.employee) {
                                            return 1;
                                        }
                                        return 0;
                                    });

                                    recordInList = this.employeeList.find(
                                        (x) => x.employeeIdentifier === this.employeeIdentifier
                                    );
                                    this.selectedEmployee = [recordInList];
                                }
                            }
                        } else {
                            if (this.employeeList?.length === 1) {
                                this.selectedEmployee = [this.employeeList[0]];
                                this.onSelectionChange();
                            }
                        }
                        resolve({});
                    },
                    (error) => {
                        this.noDataSelection.action = NoDataActionType.error;
                        throw new Error(error);
                    }
                );
        });
    }

    showNoData() {
        this.buildNoDataKpiCardData();
        this.setFundedPrductionData([], false);
        this.setProductPurposeMixCardNoData();
    }

    // LO DETAILS //////////////////////////////////
    setPositionDetails() {
        // TODO:
        // Check if employeeIdentifierRoute exists, if so, overwrite value in employeeIdentifier.
        this.detailsCard = this.performanceScorecardService.initializeScoreDetailsCard(
            ScorecardType.employee,
            this.action
        );
        let scorecardParameters = this.getParameters();
        this.performanceScorecardService.getScoreDetails(scorecardParameters).subscribe(
            (res) => {
                this.detailsCard.entityIdentifier = scorecardParameters.entityIdentifier;
                this.detailsCard = this.performanceScorecardService.updateScoreDetails(
                    this.detailsCard,
                    res
                );
            },
            (error) => {
                this.detailsCard.action = NoDataActionType.error;
                this.detailsCard.hasData = false;
                this.detailsCard.isDataLoading = false;
                this.detailsCard = Object.assign({}, this.detailsCard);
                throw new Error(error);
            }
        );
    }

    getParameters() {
        let scorecardParameters: IScorecardParameters = {
            scoreCardType: ScorecardType.employee,
            entityIdentifier: this.employeeIdentifier,
            entityType: this.employeeType,
            fromDatePeriod: this.fromDatePeriod,
            ymc: this.ymc,
            chartGroup: '',
        };
        return Object.assign({}, scorecardParameters);
    }

    // FUNDED PRODUCTION ///////////////////////////
    setFundedProduction() {
        this.largeCardInteriorOptions = this.performanceScorecardService.initializeProductionChart(
            this.pageId,
            this.action
        );

        this.performanceScorecardService.getProductionData(this.getParameters()).subscribe(
            (res: ScorecardProductionWebModel[]) => {
                this.setFundedPrductionData(res, false);
            },
            (error) => {
                this.setFundedPrductionData(undefined, true);
                throw new Error(error);
            }
        );
    }

    setFundedPrductionData(data: ScorecardProductionWebModel[], hasError = false) {
        let chartTitle = this.pageTitleShort + ' Production';
        if (hasError) {
            this.largeCardInteriorOptions.action = NoDataActionType.error;
        }
        this.largeCardInteriorOptions = this.performanceScorecardService.drawFundedProductionChart(
            data,
            this.largeCardInteriorOptions,
            chartTitle
        );
    }

    onSelectionChange() {
        this.employeeIdentifier = this.selectedEmployee[0].employeeIdentifier;
        this.router.navigate([], {
            relativeTo: this.route,
            queryParams: { id: this.employeeIdentifier },
        });
        if (this.selectedEmployee[0].forced) {
            this.employeeFoundInList = false;
            this.showNoData();
        } else {
            this.action = NoDataActionType.filter;
            this.employeeFoundInList = true;
            this.loadData();
        }
    }

    onItemDeSelect(event) {
        this.selectedEmployee = [event];
    }

    // KPI /////////////////////////////////////////
    buildNoDataKpiCardData() {
        let kpiDataHandler = new ScorecardKpicardDataHandler(
            this._reusableFunctions,
            this.sanitizer
        );
        let params: IScorecardKpiParams = {
            cardId: 'performanceLoScoreCardKpi',
            title: 'Key Performance Indicators',
            data: [],
            action: NoDataActionType.filter,
            searchTerm: '', // TODO; Set these values
            cardDrilldownUrl: '', // TODO; Set these values
            styleSet: {
                'cardlist-container-area': {
                    height: '440px',
                },
            },
            isDataReady: true,
        };
        this.kpiCardData = kpiDataHandler.initializeCards(params);
    }

    kpiInit() {
        let kpiDataHandler = new ScorecardKpicardDataHandler(
            this._reusableFunctions,
            this.sanitizer
        );
        let params: IScorecardKpiParams = {
            cardId: 'performanceLoScoreCardKpi',
            title: 'Key Performance Indicators',
            data: [],
            action: this.action,
            searchTerm: '', // TODO; Set these values
            cardDrilldownUrl: '', // TODO; Set these values
            styleSet: {
                'cardlist-container-area': {
                    height: '440px',
                },
            },
        };
        this.kpiCardData = kpiDataHandler.initializeCards(params);
        this.performanceScorecardService
            .getPositionKpi(
                this.employeeIdentifier,
                this.employeeType,
                this.fromDatePeriod,
                this.ymc
            )
            .subscribe(
                (res) => {
                    this.kpiCardData = kpiDataHandler.handleKPILargeCards(
                        this.kpiCardData,
                        res,
                        this.fromDatePeriod
                    );
                },
                (error) => {
                    params.action = NoDataActionType.error;
                    params.isDataReady = true;
                    this.kpiCardData = kpiDataHandler.initializeCards(params);
                    throw new Error(error);
                }
            );
    }

    setProductPurposeMixCard() {
        this.productionPurposeMixPieChartData =
            this.performanceScorecardService.initializeDonutcharts();
        this.productionPurposeMixPieChartData.noDataType.action = this.action;

        let scorecardParameters = this.getParameters();
        let chartGroups = ['Product', 'Purpose'];

        chartGroups.forEach((chartGroup) => {
            scorecardParameters.chartGroup = chartGroup.toLowerCase();
            this.performanceScorecardService.getPositionMix(scorecardParameters).subscribe(
                (res) => {
                    this.productionPurposeMixPieChartData =
                        this.performanceScorecardService.productPurposeMixCardLoad(
                            res,
                            this.productionPurposeMixPieChartData,
                            chartGroup
                        );
                },
                (error) => {
                    this.productionPurposeMixPieChartData['isLoading' + chartGroup + 'Mix'] = false;
                    this.productionPurposeMixPieChartData.noDataType.action =
                        NoDataActionType.error;
                    this.productionPurposeMixPieChartData =
                        this.performanceScorecardService.productPurposeMixCardLoad(
                            null,
                            this.productionPurposeMixPieChartData,
                            chartGroup
                        );
                }
            );
        });
    }

    setProductPurposeMixCardNoData() {
        let chartGroups = ['Product', 'Purpose'];
        chartGroups.forEach((chartGroup) => {
            this.productionPurposeMixPieChartData =
                this.performanceScorecardService.productPurposeMixCardLoad(
                    null,
                    this.productionPurposeMixPieChartData,
                    chartGroup
                );
        });
    }

    checkEmployeeListChanges() {
        this.loEmployeeDisplayOptionsInit().then(() => {
            if (this.employeeIdentifier) {
                if (this.employeeFoundInList) {
                    this.loadData();
                    this.isDataLoded = true;
                } else {
                    this.showNoData();
                    this.isDataLoded = true;
                }
            } else {
                this.isDataLoded = false;
            }
        });
    }

    applyDisplayOptions(event: DisplayOptions[]) {
        this.action = NoDataActionType.filter;
        this.displayOptions = event;
        this.setDisplayOptionsSelected();
        this.checkEmployeeListChanges();
    }
}
